import CartHeader from "../Cart/CartHeader";
import BikeDeilvery from "../../../assets/deliverypagebike.png";
import Delivery2 from "../../../assets/delivery2.png";
import PersonalDetails from "./PersonalDetails.jsx";
import PayementMethode from "./PayementMethode.jsx";
import OrderSummary from "../Cart/OrderSummary.jsx";
import { Link } from "react-router-dom";
import mapImage from "../../../assets/mapimage.png";
import React, { useEffect, useState } from "react";
import creditcardlogo from "../../../assets/creditcardlogo.png";
import { FaRegCircle, FaRegDotCircle, FaPaypal, FaStripe } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
// import { useStripe, useElements, CardNumberElement } from "@stripe/react-stripe-js";
import api from "../../../utils/api.js";
const Delivery = () => {
  const { discount } = useSelector((state) => state.promo);

  const [selectedMethod, setSelectedMethod] = useState("");
  const [iconSize, setIconSize] = useState(20); // Default size
  const { user } = useSelector((state) => state.user);
  const { cart } = useSelector((state) => state.cart);

  // Adjust the subtotal calculation
  const subtotal = cart.reduce((total, item) => total + item.basePrice * item.quantity, 0);
  
  // Apply discount only on applicable products
  const discountAmount = cart.reduce((discountTotal, item) => {
    const isDiscountApplicable = discount && discount.productId.includes(item._id); // Check if the discount applies to this item
    if (isDiscountApplicable) {
      discountTotal += (item.basePrice * item.quantity * discount.discount) / 100; // Apply discount only on the applicable item
    }
    return discountTotal;
  }, 0);
  
  const total = subtotal - discountAmount;
    
  console.log("Subtotal:", subtotal);
  console.log("Discount Amount:", discountAmount);
  console.log("Total:", total);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIconSize(21.66); // Large screens
      } else if (window.innerWidth >= 768) {
        setIconSize(15.15); // Medium screens
      } else {
        setIconSize(13.79); // Small screens
      }
    };

    handleResize(); // Set size initially
    window.addEventListener("resize", handleResize); // Listen for screen size changes

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);
 
  
  // Function to handle selection
  const handleSelect = (method) => {
    setSelectedMethod(method);
  };
  const paymentHandler = async (e) => {
    e.preventDefault();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
  
      const description = cart.map((item) => `${item.name} x${item.quantity}`).join(", ");
      const title = `Order of ${cart.length} items`;
      const successUrl = "https://levantecuisine.co.uk/summary";
  
      const paymentData = {
        totalPrices: total,
        description,
        title,
        successUrl,
      };
  
      // Step 1: Send payment request to backend to generate Stripe session
      const { data } = await api.post(
        `stripe/check-out/${user._id}`,
        paymentData,
        config
      );
      console.log("🚀 ~ paymentHandler ~ data:", data.session.url);
  
      if (data.session) {
        const sessionUrl = data.session.url; // Get the session URL from the backend
        console.log("Stripe Checkout URL:", sessionUrl);
  
        // Step 2: Listen for successful payment (handled via webhook or client-side polling)
        window.location.href = sessionUrl; // Redirect to the Stripe Checkout URL
  
        // Add a listener for payment success (optional if webhook is used)
        
  
        // Optional polling for payment status
      } else {
        toast.error("Failed to create payment session.");
      }
    } catch (error) {
      console.error("Error in payment handling:", error);
      toast.error("An error occurred during payment.");
    }
  };
   
  
  


  
  return (
    <>
      <CartHeader />
      
   
      <div className="flex overflow-hidden flex-col">
        <OrderSummary />
      </div>
      <div className="container mx-auto mt-8 w-[90%] md:w-[90%] shadow-md  bg-stone-50 border-[#FDFDFD] border md:mb-5">
      <h1 className="lg:text-[59.61px] text-[24px] md:text-[41.68px] sm:text-[24px] font-baloo font-semibold text-center mb-6">
        Payment Method
      </h1>

      <form className="w-[90%] md:w-full mx-auto  md:p-6 p-0 rounded-lg sm:mb-3 mb-3">
        <div className="flex flex-col md:gap-8 gap-8 md:flex-row md:space-x-4 mb-4">
          {/* Credit/Debit Card Option */}
          <div className="flex-1 gap-4 flex flex-col relative">
            <label
              className="relative w-full cursor-pointer"
              onClick={() => handleSelect("creditcard")}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="creditcard"
                className="hidden"
              />
              <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] sm:h-[42.8px] border-gray-300 rounded-md placeholder:text-[9.91px] sm:placeholder:text-[9.91px] md:placeholder:text-[10.93px] lg:placeholder:text-[15.63px] hover:border-blue-500 transition duration-200">
                {selectedMethod === "creditcard" ? (
                  <FaRegDotCircle className="text-blue-500 " size={iconSize} />
                ) : (
                  <FaRegCircle className="text-gray-500 " size={iconSize} />
                )}
                <img
                  src={creditcardlogo}
                  alt="Logo"
                  className="h-[17.25px] w-[24.83px] sm:h-[17.25px] sm:w-[24.83px] lg:w-[38.99px] lg:h-[28.16px] mr-2"
                />
                <span className="lg:text-[25.99px] md:text-[18.18px] text-[16.55px] sm:text-[16.55px] text-[#515978] font-baloo font-medium">
                  Credit Card / Debit Card
                </span>
              </div>
            </label>
          </div>

          {/* Stripe Option */}
          <div className="flex-1 gap-4 flex flex-col relative">
            <label
              className="relative w-full cursor-pointer"
              onClick={(event) => {
                handleSelect("stripe");
              }}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="stripe"
                className="hidden"
              />
              <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] sm:h-[42.8px] border-gray-300 rounded-md placeholder:text-[9.91px] sm:placeholder:text-[9.91px] md:placeholder:text-[10.93px] lg:placeholder:text-[15.63px] hover:border-blue-500 transition duration-200">
                {selectedMethod === "stripe" ? (
                  <FaRegDotCircle className="text-blue-500"size={iconSize} />
                ) : (
                  <FaRegCircle className="text-gray-500" size={iconSize}/>
                )}
             <FaStripe className="text-[#635BFF] text-2xl sm:text-3xl md:text-4xl lg:text-6xl" />
                <span className="lg:text-[25.99px] md:text-[18.18px] text-[16.55px] sm:text-[16.55px] text-[#515978] font-baloo font-medium">
                  Stripe
                </span>
              </div>
            </label>
          </div>
        </div>

        <div className="flex md:space-x-4 mb-4 md:gap-8 flex-col md:flex-row">
          {/* PayPal Option */}
          <div className="flex-1 gap-4 flex flex-col relative mt-4">
            <label
              className="relative w-full cursor-pointer"
              onClick={() => handleSelect("paypal")}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="paypal"
                className="hidden"
              />
              <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] sm:h-[42.8px] border-gray-300 rounded-md placeholder:text-[9.91px] sm:placeholder:text-[9.91px] md:placeholder:text-[10.93px] lg:placeholder:text-[15.63px] hover:border-blue-500 transition duration-200">
                {selectedMethod === "paypal" ? (
                  <FaRegDotCircle className="text-blue-500"size={iconSize} />
                ) : (
                  <FaRegCircle className="text-gray-500" size={iconSize}/>
                )}
                <FaPaypal className="text-[#27346A] text-2xl sm:text-2xl md:text-3xl lg:text-4xl" />
                <span className="lg:text-[25.99px] text-[16.55px] sm:text-[16.55px] md:text-[18.18px] text-[#515978] font-baloo font-medium">
                  PayPal
                </span>
              </div>
            </label>
          </div>
          <div className="flex-1"></div>
        </div>
      </form>
    </div>
        <button
          onClick={(event) => {
            paymentHandler(event);  // Call the payment handler
          }}
        className=" flex items-center mx-auto justify-center lg:w-[258.19px] md:w-[180.41px] md:h-[52.44px] w-[132.74px] h-[29.28px] sm:w-[132.74px] sm:h-[29.28px] lg:h-[75px] bg-[#AF313D] px-2 py-2 lg:mt-8 text-white  shadow-md mt-2  text-[15.43px] sm:text-[15.43px] lg:text-[26px] font-baloo font-semibold rounded-[2rem] md:text-[18.18px] mb-3">
          Proceed
        </button>
    </>
  );
};

export default Delivery;
